export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center pt-20"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/5a011118974e778210c4c00fdeb85baf.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-transparent"></div>
      
      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-8 py-24">
        <div className="max-w-2xl">
          <div className="inline-flex items-center space-x-2 bg-teal-50 px-4 py-2 rounded-full mb-8">
            <i className="ri-shield-check-line text-teal-600 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="text-teal-700 text-sm font-medium">Trusted VPN Solution</span>
          </div>
          
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Secure Your Digital Life with <span className="text-teal-600">SALVI VPN</span>
          </h2>
          
          <p className="text-xl text-gray-600 mb-10 leading-relaxed">
            Experience ultimate online privacy and security with our advanced VPN application. Browse safely, protect your data, and access content freely from anywhere in Colombia and beyond.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <button onClick={scrollToContact} className="bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap">
              Get Started Now
            </button>
            <button onClick={scrollToContact} className="bg-white text-gray-900 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-50 transition-all border-2 border-gray-200 cursor-pointer whitespace-nowrap">
              Contact Us
            </button>
          </div>
          
          <div className="mt-12 flex items-center space-x-8">
            <div>
              <div className="text-3xl font-bold text-gray-900">256-bit</div>
              <div className="text-sm text-gray-600">Encryption</div>
            </div>
            <div className="w-px h-12 bg-gray-300"></div>
            <div>
              <div className="text-3xl font-bold text-gray-900">24/7</div>
              <div className="text-sm text-gray-600">Support</div>
            </div>
            <div className="w-px h-12 bg-gray-300"></div>
            <div>
              <div className="text-3xl font-bold text-gray-900">Fast</div>
              <div className="text-sm text-gray-600">Connection</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
